import React from 'react'
import { IoCloseCircle } from 'react-icons/io5'

const PreviewModal = ({toggleModal,handleToggle,preview,title}) => {
    if(toggleModal){ 
  return (
    <div className='modal2' >
      <div className='bg-white relative w-[95vw] lg:w-[50vw] p-6 flex flex-col space-y-6 rounded shadow-md max-h-[90vh] '>
          <h3 className='text-left text-2xl text-black'>{title?`${title} Preview`:"Modal Preview"}</h3>
      {preview}
      <IoCloseCircle onClick={handleToggle} className="absolute right-3 -top-3 text-red-600 text-2xl self-top cursor-pointer transition-all ease-in-out hover:scale-110"/>
      </div>
      
    </div>
  )
    }
  return(<></>)
}
export default PreviewModal
